export default "__VITE_ASSET__CEGS1b9M__"